<template>
  <closed-card v-if="collapsed" :card-text="title"/>
  <div v-else class="creds-selection" v-bind:class="[firstSelectionText, { 'disabled': disabled }]">
    <div class="description border-bottom">
      <div class="title">{{ title }}</div>
      <div v-if="subtitle" class="subtitle">{{ subtitle }}</div>
    </div>
    <selected-sources :selectedSources="selectedSources" :removeSource="removeSource"></selected-sources>
    <div class="border-bottom">
      <source-selection
        :disabled="disabled"
        :selectionText="selectionText"
        :sources="sources"
        :sourceType="sourceType"
        :scrollable="scrollable"
        :addSource="addSource">
      </source-selection>
    </div>
    <div class="card-button-wrapper">
      <card-button :disabled="!hasSelectedSources" :cardStyle="'primary'" :title="'סיימתי'" :action="clickFinished"></card-button>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Segment from '../../../Segment';

import SourceSelection from './SourceSelection.vue';
import SelectedSources from './SelectedSources.vue';
import CardButton from '../../card-parts/CardButton.vue';
import ClosedCard from '../../ClosedCard.vue';
import SourceFields from '../../../mixins/SourceFields.vue';

export default {
  name: 'CredentialSelectCard',
  mixins: [SourceFields],
  components: {
    SelectedSources,
    SourceSelection,
    CardButton,
    ClosedCard,
  },
  data() {
    return {
      collapsed: false,
    };
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    firstSelectionText: {
      type: String,
      default: 'הוספת חשבון',
    },
    scrollable: Boolean,
    sourceType: String,
    action: Function,
    selectedSources: Array,
    addSource: Function,
    removeSource: Function,
  },
  computed: {
    hasSelectedSources() {
      return !_.isEmpty(this.selectedSources);
    },
    selectionText() {
      if (_.isEmpty(this.selectedSources)) {
        return this.firstSelectionText;
      }
      return 'הוספת חשבון';
    },
    sourceTypes() {
      return {
        CARD: 'card',
        BANK: 'bank',
      };
    },
    title() {
      if (this.sourceType === this.sourceTypes.CARD) {
        return 'כרטיסי אשראי';
      }
      return 'בנקים';
    },
    subtitle() {
      if (this.sourceType === this.sourceTypes.CARD) {
        return 'צריך לחפש על כרטיס האשראי את הלוגו של אחת מחברות האשראי שמופיעות כאן. ככה תדעו איזה חשבון להוסיף.';
      }
      return '';
    },
    sources() {
      if (this.sourceType === this.sourceTypes.CARD) {
        return _.filter(this.allSourceFields, source => source.type === this.sourceTypes.CARD && !source.hidden);
      }
      return _.filter(this.allSourceFields, source => source.type === this.sourceTypes.BANK && !source.hidden);
    },
  },
  methods: {
    clickFinished() {
      if (this.sourceType === this.sourceTypes.CARD) {
        Segment.trackUserInteraction('CardDoneClicked');
      } else {
        Segment.trackUserInteraction('BankDoneClicked');
      }
      this.collapsed = true;
      this.action();
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../node_modules/base-ui/src/scss/riseup-colors';
  @import '../../../scss/mixins';

  .creds-selection {
    @include card;

    .description {
      @include card-top;

      .title {
        @include card-title;
      }

      .subtitle {
        margin-top: 16px;
        font-family: SimplerPro;
        font-size: 20px;
        line-height: 1.2em;
      }
    }

    .card-button-wrapper {
      padding: 30px;
    }

    .border-bottom {
      border-bottom: solid 1px $riseup_gray_0;
    }
  }

  .disabled {
    .description {
      color: $riseup_gray_1;
    }
  }

</style>
